// Enums
export enum Suffix {
  SHORT = 'SHORT',
  UNGUESSABLE = 'UNGUESSABLE',
}

// Interfaces for nested structures
export interface AndroidInfo {
  androidPackageName?: string;
  androidFallbackLink?: string;
  androidMinPackageVersionCode?: string;
}

export interface IosInfo {
  iosBundleId?: string;
  iosFallbackLink?: string;
  iosCustomScheme?: string;
  iosIpadFallbackLink?: string;
  iosIpadBundleId?: string;
  iosAppStoreId?: string;
}

export interface GooglePlayAnalytics {
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
  utmTerm?: string;
  utmContent?: string;
}

export interface ItunesConnectAnalytics {
  at?: string;
  ct?: string;
  mt?: string;
  pt?: string;
}

export interface AnalyticsInfo {
  googlePlayAnalytics?: GooglePlayAnalytics;
  itunesConnectAnalytics?: ItunesConnectAnalytics;
}

export interface NavigationInfo {
  enableForcedRedirect?: boolean;
}

export interface SocialMetaTagInfo {
  socialTitle?: string;
  socialDescription?: string;
  socialImageLink?: string;
}

export interface DynamicLinkInfo {
  domainUriPrefix: string;
  link: string;
  androidInfo?: AndroidInfo;
  iosInfo?: IosInfo;
  analyticsInfo?: AnalyticsInfo;
  navigationInfo?: NavigationInfo;
  socialMetaTagInfo?: SocialMetaTagInfo;
}

export interface ShortenLinkRequest {
  dynamicLinkInfo: DynamicLinkInfo,
  suffix: Suffix
}
